<template>
  <Header />
  <div class="section container section--md">
    <div class="content">
      <h1>Admin</h1>
      <div class="heading d-flex flex-column justify-content-between align-items-center">
        <Types />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Types from '../components/admin/Types.vue';

export default {
  name: 'Admin',
  components: {
    Header, Types
  },
  data() {
    return {
      types: []
    }
  },
  mounted() {
    document.body.classList.remove('menu-open');
  },
  methods: {
  },
}
</script>
<style scoped>
</style>
